// Route paths constants for better maintainability
export const ROUTES = {
  // Public routes
  LOGIN: '/login',
  SIGNUP: '/signup',
  EMPLOYEE_LOGIN: '/employee-login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  EMPLOYEE_FORGOT_PASSWORD: '/employee-forgot-password',
  EMPLOYEE_RESET_PASSWORD: '/employee-reset-password',
  CONTACT_US: '/contact-us',
  HELP_CENTER: '/help-center',
  COACH_CORNER: '/coach-corner',

  // Private routes
  DASHBOARD: '/dashboard',
  SEASONS: '/seasons',
  SEASON_DETAILS: '/seasons/:seasonId',
  GAMES: '/games',
  GAME_DETAILS: '/games/:gameId',
  GAME_DETAILS_SPECIFIC: '/game-details',

  // Setup routes (Admin only - no /setup prefix)
  CLIENTS: '/clients',
  USERS: '/users',
  PLAYERS: '/players',
  OPPONENTS: '/opponents',
  BILLING: '/billing',
} as const;

// Helper functions for dynamic routes
export const getSeasonRoute = (seasonId: string) => `/seasons/${seasonId}`;
export const getGameRoute = (gameId: string) => `/games/${gameId}`;
export const getSeasonGamesRoute = (seasonId: string) => `/seasons/${seasonId}/games`;
export const getGameStatsRoute = (gameId: string) => `/games/${gameId}`;

export default ROUTES;
